<template>
  <section
    id="services"
    class="hide-overflow"
  >
    <v-layout accent>
      <v-flex
        hidden-sm-and-down
        md6
      >
        <v-img
          :src="require('@/assets/mccoygarden.jpg')"
          height="100%"
        />
      </v-flex>
      <v-flex
        xs12
        md6
        text-xs-center
        pa-5
      >
        <v-layout
          align-center
          justify-center
          fill-height
          wrap
        >
          <v-flex xs12>
            <base-bubble-2
              style="transform: translateX(55%)"
            />
            <base-heading class="info--text">
              Services
            </base-heading>

            <base-text class="mb-5 font-weight-bold">
              I am on a mission to better my community and society through technology.<br>
              Feel free to contact me if your interested in doing the same.
            </base-text>
          </v-flex>
          <v-flex
            v-for="(service, i) in services"
            :key="i"
            md6
            text-xs-center
            mb-3
          >
            <v-avatar
              class="elevation-6 mb-2"
              color="#69A1BB"
              size="64"
              tile
            >
              <v-icon
                dark
                size="52"
                v-text="service.icon"
              />
            </v-avatar>
            <base-text>
              <div
                class="mb-2 font-weight-bold"
                v-text="service.name"
              />
              <div v-html="service.blurb" />
            </base-text>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
export default {
  data: () => ({
    services: [
      {
        name: 'Crypto/Programming Consulting & Mentoring ',
        icon: 'mdi-clipboard-text-outline',
        blurb: 'Experienced, Patient ,Respectful mentor for beginners.<br> Trust me i know what it is not to know anything about computers.'
      },
      {
        name: 'Web & App Development',
        icon: 'mdi-pencil-outline',
        blurb: 'Im a Creative, Ethusiastic, Focused Developer always looking for great ideas to develop. <br> Always looking for potential trustworthy business partners.'
      },
      {
        name: 'Youtube Content Creator',
        icon: 'mdi-settings-outline',
        blurb: 'Follow me on Youtube @ Crypto Rootz for Valuable Crypto Game,<br> I got cha back in this Crazy Digital World.'
      },
      {
        name: 'Marketing & Tutorials',
        icon: 'mdi-account',
        blurb: 'Always on the lookout for dope companies that offer unique yet useful services and products, <br>I post & sell crypto/programming tutotrials.'
      }
    ]
  })
}
</script>
